"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonBufferTransform = exports.toJson = exports.fromJson = exports.getCircularReferenceReplacer = void 0;
const getCircularReferenceReplacer = () => {
    const seen = new WeakSet();
    return (key, value) => {
        if (typeof value === 'object' && value !== null) {
            if (seen.has(value)) {
                return;
            }
            seen.add(value);
        }
        return value;
    };
};
exports.getCircularReferenceReplacer = getCircularReferenceReplacer;
const fromJson = (data) => {
    return JSON.parse(data);
};
exports.fromJson = fromJson;
const toJson = (data, indentLevel) => {
    return JSON.stringify(data, exports.getCircularReferenceReplacer(), indentLevel);
};
exports.toJson = toJson;
class JsonBufferTransform {
    constructor(schema = undefined) {
        this.schema = schema;
    }
    transform(buffer) {
        const rawShape = exports.fromJson(buffer.toString());
        if (this.schema) {
            return this.schema.parse(rawShape);
        }
        else {
            return rawShape;
        }
    }
}
exports.JsonBufferTransform = JsonBufferTransform;
